import classes from '../Home.module.scss'
import Button from '../../shared/ComponentLibrary/RButton'
import useAuthentication from '../../../customHooks/useAuthentication'



const MobileDetectionMessage = () => {
  const { signOut } = useAuthentication()

  return (
    <div className={classes.sm_container}>
      <div className={classes.mobile_warning}>
        <p>Thank you for signing up with ReviewRight! Your account is now activated.</p>
        <p>If you wish to access ReviewRight from a mobile device, please download the ReviewRight Mobile app from the App Store&reg; or Google Play Store:</p>
        <div className={classes.app_links}>
          <a href="https://apps.apple.com/us/app/reviewright/id6746771031"><img className={classes.apple_app_store_link} src={'/images/apple-app-store-official-large3.webp'} alt="Apple App Store link" width="1895" height="633" /></a>
          <a href="https://play.google.com/store/apps/details?id=org.HayStackID.ReviewRight"><img className={classes.google_play_store_link} src={'/images/btn-get-it-on-google-play-official.webp'} alt="Google Play Store link" width="2179" height="647" /></a>
        </div>
        <p>Please note that the ReviewRight website is not supported on mobile devices.</p>
        
        <p>You can log in to the ReviewRight website from a desktop computer with a fast, stable internet connection. That will allow you to take any assessments.</p>
        <div className='d-flex justify-content-center mt-5'>
          <Button innerText="Sign Out" onClickMethod={signOut}/>
        </div>
        <div className={classes.disclaimer}>
          Apple&reg;, the Apple logo&reg; and the App Store are trademarks of Apple Inc., registered in the U.S. and other countries. Google Play is a trademark of Google LLC.
        </div>
      </div>
    </div>
  )
}

export default MobileDetectionMessage
